import dash_api from '../../support/dash_api';
import { ReduxAsyncAction } from '../../support/utils';

const GenerateTestLink = new ReduxAsyncAction('GENERATE_3P_TEST_LINK');
GenerateTestLink.registerRequest(function (url, threeP) {
  return dash_api
    .post('/v1/3p-onboarding/generate-3pURL', {
      url,
      threeP,
    })
    .then(({ data }) => data);
});

export const generateTestLink = GenerateTestLink.request;
export const GENERATE_3P_TEST_LINK = GenerateTestLink.constants;
